import { useContext, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import clsx from "clsx";
import { context } from "@/Layout";
import useUtils from "@/hooks/useUtils";
import { usePadding } from "@/components/utils/Padding";
import { ButtonPropTypes } from "./propTypes";
import "./styles.scss";

const Button = (props) => {
  const {
    button_icon_position: buttonIconPosition = "left",
    button_icon: buttonIcon,
    button_link: buttonLink,
    button_order: buttonOrder,
    button_padding: buttonPadding,
    button_position: buttonPosition,
    button_size: size = "button__medium",
    display_button_order: displayButtonOrder,
    display_button: displayButton,
    fullWidth = false,
  } = props;
  const { lenisInstance } = useContext(context);

  const { convertToRelative } = useUtils();

  const paddingStyle = usePadding(buttonPadding);

  const buttonStyle = {
    ...paddingStyle,
    ...(displayButtonOrder && { order: buttonOrder || 0 }),
    alignItems: buttonPosition,
  };

  const isSectionLink = useMemo(
    () => buttonLink?.url?.length > 1 && buttonLink?.url?.startsWith("#"),
    [buttonLink]
  );

  const scrollToSection = (section) => {
    if (!section) return;

    const id = section.startsWith("#") ? section.slice(1) : section;
    const el = document.getElementById(id);
    if (!el) return;

    const headerOffset = document.querySelector("[data-sticky-header]")?.offsetHeight ?? 0;
    const offset = -headerOffset;

    if (lenisInstance) {
      lenisInstance.scrollTo(section, { offset });
    } else {
      window.scrollTo(0, 0);
    }
  };

  if (!displayButton || !buttonLink) {
    return null;
  }

  return (
    <motion.div
      className="button-component"
      style={buttonStyle}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
    >
      {isSectionLink ? (
        <button
          className={clsx("button btn-hover-effect", {
            "w-full justify-center": fullWidth,
            [size]: size,
          })}
          onClick={() => scrollToSection(buttonLink.url)}
          target={buttonLink.target}
        >
          {buttonIcon && buttonIconPosition === "left" && (
            <i className="mr-2">
              <img className="button-icon" src={buttonIcon.url} alt={buttonIcon.alt} />
            </i>
          )}

          <span dangerouslySetInnerHTML={{ __html: buttonLink.title }} />

          {buttonIcon && buttonIconPosition === "right" && (
            <i className="ml-2">
              <img className="button-icon" src={buttonIcon.url} alt={buttonIcon.alt} />
            </i>
          )}
        </button>
      ) : (
        <NavLink
          className={clsx("button btn-hover-effect", {
            "w-full justify-center": fullWidth,
            [size]: size,
          })}
          target={buttonLink.target}
          to={convertToRelative(buttonLink.url)}
        >
          {buttonIcon && buttonIconPosition === "left" && (
            <i className="mr-2">
              <img className="button-icon" src={buttonIcon.url} alt={buttonIcon.alt} />
            </i>
          )}

          <span>{buttonLink.title}</span>

          {buttonIcon && buttonIconPosition === "right" && (
            <i className="ml-2">
              <img className="button-icon" src={buttonIcon.url} alt={buttonIcon.alt} />
            </i>
          )}
        </NavLink>
      )}
    </motion.div>
  );
};

Button.propTypes = ButtonPropTypes;

export default Button;
